// if we don't need to check constraint, here we don't need a path search anymore
// totoal should be the sum of float result, to avoid sum value like .99999999 or .0000001
// we use total instead of sum(floatResult)
// input is like  [1.6,1.6,1.6,1.6,1.6] , 8
export const round = (floatResult: number[], total: number) => {
    const floorAndSortResult = floorAndSort(floatResult);

    // If list of numbers are all zero, nothing should be rounded/allocated
    if (floatResult.filter((float) => float === 0).length === floatResult.length) {
        return floatResult;
    }
    const integerResult: number[] = floorAndSortResult[0];
    const fractionalOrder: number[] = floorAndSortResult[1];
    const integerSum = sum(integerResult);
    // const fractionSum = sum(integerResult);
    const allocateNumber: number = total - integerSum;
    for (let i = 0; i < allocateNumber; i++) {
        integerResult[fractionalOrder[i]] = integerResult[fractionalOrder[i]] + 1;
    }
    return integerResult;
};

function floorAndSort(floatResult: number[]) {
    const integerResult = new Array<number>(0);
    const fractionResult = new Array<number[]>(0);
    for (let i = 0; i < floatResult.length; i++) {
        integerResult.push(Math.floor(floatResult[i]));
        fractionResult.push([floatResult[i] - Math.floor(floatResult[i]), i]);
    }
    // desc sort   [[0.5,0],[0.7,1],[0.6,2],[0.8,3]] => [[0.8,3],[0.7,1],[0.6,2],[0.5,0]]
    const sortedFractionResult = fractionResult.sort((a, b) => {
        return b[0] - a[0];
    });
    const fractionalOrder = new Array<number>(0);
    // =>[3,1,2,0]
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < sortedFractionResult.length; i++) {
        fractionalOrder.push(sortedFractionResult[i][1]);
    }
    return [integerResult, fractionalOrder];
}

function sum(integerResult: number[]): number {
    let sumResult: number = 0;
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < integerResult.length; i++) {
        sumResult = sumResult + integerResult[i];
    }
    return sumResult;
}
